const injectAppcuesScript = (appcuesAccountId, param)=>{
    let { src, integrity = '' } = param;
    const appcuesScriptId = 'appcues-bootstrap';
    return new Promise((resolve)=>{
        if (document.getElementById(appcuesScriptId)) {
            resolve();
        } else {
            window.AppcuesSettings = {
                enableURLDetection: true
            };
            window.appcuesAccountId = appcuesAccountId;
            const script = document.createElement('script');
            script.id = appcuesScriptId;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.type = 'text/javascript';
            script.src = src;
            script.setAttribute('integrity', integrity);
            script.onload = ()=>resolve();
            document.head.appendChild(script);
        }
    });
};
export const loadAppcuesOld = (appcuesAccountId)=>injectAppcuesScript(appcuesAccountId, {
        src: 'https://cdn.anchor.sh/appcues/appcues-bootstrap.js',
        integrity: 'sha384-0WU2TUOJTyy11Iqf6ViiHLuqyhmagqyTyHnyxmMoRnKHAIK/wef8Y/KqAbvIFHaY'
    });
export const loadAppcues = (appcuesAccountId)=>injectAppcuesScript(appcuesAccountId, {
        src: "https://fast.appcues.com/".concat(appcuesAccountId, ".js")
    });
export const getAppcuesLoader = (featureFlags)=>(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.APPCUES_LATEST_SDK) ? loadAppcues : loadAppcuesOld;
